module.exports = __webpack_public_path__ + "static/img/4.f0d539b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/8/eng/4.png
// module id = s47H
// module chunks = 0